import React from "react";

import { RaffleTable, TicketsDisplayer, TombolaTop } from "../../components";
import TombolaTcRender from "./TombolaTcRender";
import TombolaTopRender from "./TombolaTopRender";
import { ITombolaPageRenderProps } from "../../interfaces/ITombolaPageProps";
import CustomHeaderV1 from "@/app/(custom-header)/header/customHeaderV1";
// const LeaderboardTable = lazy(() => import("@/app/(custom-header)/spring-daily-raffle/components/LeaderboardTable"));
import { EarnPoints } from "@/app/(custom-header)/spring-daily-raffle/components/EarnPoints";
import InstantPrizes from "../../components/InstantPrizes";
import TicketsDisplayerRender from "./TicketsDisplayerRender";
import TombolaStickyRender from "./TombolaStickyRender";
import { getCookie } from "../../../../../../helpers/cookies";
import RaffleTableRender from "./RaffleTableRender";
import { useRaffleContext } from "@/app/(custom-header)/spring-daily-raffle/context";

const TombolaPageRender = (props: ITombolaPageRenderProps) => {
  const isAuth = getCookie("BotB.Authenticated") === "true";
  const { isEndState } = useRaffleContext();
  return (
    <div className={"relative bg-[#EFEFEF] spring-raffle-main-section"}>
      <CustomHeaderV1 hideBadge={isEndState} />
      <TombolaTop Render={TombolaTopRender} isEndState={isEndState} />
      {!isEndState && <TicketsDisplayer Render={TicketsDisplayerRender} />}
      {!isEndState && <EarnPoints />}
      {isAuth && !isEndState ? <RaffleTable Render={RaffleTableRender} /> : null}
      {!isEndState && <InstantPrizes />}
      {/* {isEndState && (
        <div className={"-mt-[160px] lg:-mt-[184px] mb-8 lg:mb-[56px] mx-auto lg:max-w-[1412px] relative"}>
          <Suspense
            fallback={
              <div className="px-3 lg:px-6">
                <Skeleton className="w-full max-w-2xl lg:max-w-[700px] mx-auto" height={400} borderRadius={8} />
              </div>
            }>
            <LeaderboardTable />
          </Suspense>
        </div>
      )} */}
      {isEndState && (
        <div className={"-mt-[160px] lg:-mt-[184px]"}>
          <RaffleTable Render={RaffleTableRender} />
        </div>
      )}

      <TombolaTcRender />
      {!isEndState && <TombolaStickyRender />}
    </div>
  );
};

export default TombolaPageRender;
